import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=27b652c9&"
import script from "./Events.vue?vue&type=script&lang=js&"
export * from "./Events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mike/Sites/SchulmanTheatres/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27b652c9')) {
      api.createRecord('27b652c9', component.options)
    } else {
      api.reload('27b652c9', component.options)
    }
    module.hot.accept("./Events.vue?vue&type=template&id=27b652c9&", function () {
      api.rerender('27b652c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Events.vue"
export default component.exports